import { Button } from "design-system/atoms/Button"
import { Tags } from "lucide-react"
import { useRequestShopifyMetafieldsAuditMutation } from "modules/backoffice/hooks/shopifyMetafieldsAudit/useRequestShopifyMetafieldsAuditMutation"
import { useTranslation } from "react-i18next"

type Props = {
  companyId: string
}

export const BackofficeShopifyMetafieldsAuditButton = ({ companyId }: Props) => {
  const { t } = useTranslation()
  const { mutate, isPending } = useRequestShopifyMetafieldsAuditMutation()

  return (
    <Button
      variant="outline"
      className="flex gap-2"
      disabled={isPending}
      onClick={() => mutate({ companyId })}
    >
      <Tags />
      {t("backoffice.shopifyMetafieldsAudit.action")}
    </Button>
  )
}
